<div *ngIf="createForm">
  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 7">
    <div class="row">
      <div class="col-md-11">
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 7">{{ getIntitule(indexPage) | translate }}</legend>


            <app-step2common [uid]="getUidCommon(1)" [parentForm]="form"
                             [disabled]="disabled" [fnSimple]="ann.fnSimple" *ngIf="indexPage === 1"
                             [linkForRouter]="linkForRouter"></app-step2common>
            <app-step1 [uid]="getUid(2)" [parentForm]="form" [disabled]="disabled"
                       [fnSimpleInitial]="ann.fnSimple?.initialFromFNSimple" *ngIf="indexPage === 2"
                       [linkForRouter]="linkForRouter">
            </app-step1>
            <app-step2 [uid]="getUid(3)" [parentForm]="form" [disabled]="disabled"
                       [fnSimpleInitial]="ann.fnSimple?.initialFromFNSimple" *ngIf="indexPage === 3"
                       [linkForRouter]="linkForRouter">
            </app-step2>
            <app-step3 [uid]="getUid(4)" [parentForm]="form" [disabled]="disabled"
                       [fnSimpleInitial]="ann.fnSimple?.initialFromFNSimple" *ngIf="indexPage === 4"
                       [linkForRouter]="linkForRouter">
            </app-step3>
            <app-step4 [uid]="getUid(5)" [parentForm]="form" [disabled]="disabled"
                       [fnSimpleInitial]="ann.fnSimple?.initialFromFNSimple" *ngIf="indexPage === 5"
                       [linkForRouter]="linkForRouter"></app-step4>
            <app-step5 [uid]="getUid(6)" [parentForm]="form" [disabled]="disabled"
                       [fnSimpleInitial]="ann.fnSimple?.initialFromFNSimple" *ngIf="indexPage === 6"
                       [linkForRouter]="linkForRouter"></app-step5>
            <div class="text-danger" *ngIf="!isFormValid">ce formulaire comporte des erreurs</div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
